import * as types from '../constants/profileConstants';
import _ from 'underscore';

const initialState = {
  tradingHours: {},
  tradingHoursLoading: false,
  merchants: [],
  merchantsLoading: false
};

export default function profile(state = initialState, action) {
  switch(action.type) {
    case types.GET_TRADING_HOURS:
    case types.POST_TRADING_HOURS:
      return Object.assign({}, state, {  tradingHoursLoading: true });
    case types.UPDATE_TRADING_HOURS:
      return Object.assign({}, state, { 
        tradingHours: _.object(_.map(action.hours, (h) => { return [h.key, { ...h, value: h.openHours }]; })),
        tradingHoursLoading: false
      });
    case types.POST_TRADING_HOURS_SUCCESS:
      return Object.assign({}, state, {  tradingHoursLoading: false });
    case types.GET_MERCHANTS:
      return Object.assign({}, state, { merchants: [], merchantsLoading: true });
    case types.GET_MERCHANTS_SUCCESS:
      return Object.assign({}, state, { merchants: action.response, merchantsLoading: false });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./app/profile/reducers/profile.js